import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const PointsAnimation = ({ x, y, points, color, onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 1000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  const displayText = typeof points === 'number' 
    ? (points > 0 ? `+${points}` : points)
    : points;

  return (
    <motion.div
      initial={{ opacity: 1, y: 0, scale: 1 }}
      animate={{ opacity: 0, y: -50, scale: 1.2 }}
      transition={{ duration: 1, ease: 'easeOut' }}
      className="fixed pointer-events-none z-[100] font-bold text-xl"
      style={{
        left: x,
        top: y,
        color: color || (typeof points === 'number' && points < 0 ? '#ef4444' : '#10b981'),
        textShadow: '0 2px 4px rgba(0,0,0,0.3)'
      }}
    >
      {displayText}
    </motion.div>
  );
};

export default PointsAnimation;